import { compact } from "fgr-lib-business-logic/lib/common/functional"
import {
    CategoriesQuery2_ModifierGroups,
    CategoriesQuery2ProductCategories,
    Maybe,
    MerchantInfoQueryMerchantInfo,
    MerchantInfoQueryMibLocations,
    MerchantInfoQuerySettings,
} from "../graphql/generated-types"

export const getLocationInfo = (
    merchantInfo: Maybe<MerchantInfoQueryMerchantInfo>,
    locationSlug: string
): Maybe<MerchantInfoQueryMibLocations> => {
    if (merchantInfo) {
        return merchantInfo.mibLocations.find(l => l.slug === locationSlug)
    } else {
        return null
    }
}

export const hasMultipleLocations = (merchantInfo): boolean => {
    if (merchantInfo.hasMultipleLocations === true) {
        // additional test - some locations could be hidden/disabled, so count them
        return merchantInfo.mibLocations.length > 1
    } else {
        return false
    }
}

export const getLocationSettings = (
    locationInfo: Maybe<MerchantInfoQueryMibLocations>
): Maybe<MerchantInfoQuerySettings> => {
    return (locationInfo && locationInfo.settings) || null
}

export const ePurchaseEnabled = (locationSettings: MerchantInfoQuerySettings): boolean =>
    locationSettings.ePurchaseEnabled

export const addUniqueModifierGroupsDataToCategories = (
    categories: Maybe<CategoriesQuery2ProductCategories[]>,
    uniqueModifierGroups: Maybe<CategoriesQuery2_ModifierGroups[]>
): CategoriesQuery2ProductCategories[] => {
    return (categories || []).map(c => ({
        ...c,
        products: [
            ...(c.products || []).map(p => ({
                ...p,
                modifierGroups: compact(
                    (p.modifierGroups || []).map((mG, i) => {
                        const modifierGroup = (uniqueModifierGroups || []).find(
                            uMG => uMG.categoryGroupUniqueId === mG.categoryGroupUniqueId
                        )
                        if (!modifierGroup) {
                            return null
                        }
                        return {
                            ...mG,
                            ...modifierGroup,
                            sortIndex: i,
                        }
                    })
                ),
            })),
        ],
    }))
}
